import { render, staticRenderFns } from "./screen-album.vue?vue&type=template&id=9a9319c0"
import script from "./screen-album.vue?vue&type=script&lang=ts"
export * from "./screen-album.vue?vue&type=script&lang=ts"
import style0 from "./screen-album.vue?vue&type=style&index=0&id=9a9319c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports